import CollectionBox from "../Components/Home/Collection/CollectionBox.tsx";
import HeroSection from "../Components/Home/Hero/HeroSection.tsx";
import Services from "../Components/Home/Services/Services.tsx";
import Trendy from "../Components/Home/Trendy/Trendy.tsx";

const Home = () => {
  return (
    <div className="az">
      <HeroSection />
      <main className="az-wrap">
        <Trendy />
        <Services />
      </main>
      <CollectionBox />
    </div>
  );
};

export default Home;
